import httpRequest from "~/composables/requset";

// 取得廠商資訊
export function getAdminInfo(id: number, failFunc?: any): Promise<ResponseData> {
    const queryData = {admin_id: id}
    return httpRequest(
        'POST',
        '/api/website/info',
        queryData,
        failFunc
    )
}
